





















































































import Vue from 'vue'
import { TenantAppServiceProxy, TenantApp } from '@/service-proxies/app-v2/system.service-proxies'
import moment from 'moment'
const sp = new TenantAppServiceProxy()
export default Vue.extend({
  props: {
    app: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      moment,
      now: Date.now()
    }
  },
  methods: {
    save() {
      this.form.validateFields(async (err: any, vals: any) => {
        if (!err) {
          try {
            this.loading = true
            const body: any = {
              appAvatar: this.app.appAvatar,
              appCode: this.app.appCode,
              id: this.app.id,
              tenantId: this.app.tenantId,
              appDisplayName: this.app.appDisplayName,
              sort: vals.sort,
              expireTime: vals.expireTime.format('YYYY-MM-DD HH:mm:ss')
            }
            await sp.updateGrantAppForTenant(body)
            this.$message.success('修改成功')
            this.loading = false
            this.form.resetFields()
            this.$emit('close')
          } catch (e) {
            console.log(e)
            this.form.resetFields()
            this.loading = false
          }
        }
      })
    },
    timeValidator(rule: any, value: any, cb: Function) {
      if (value) {
        if (value.valueOf() < this.now) {
          cb('不应授权过去时间')
        }
      }
      cb()
    }
  }
})
